var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 10C17.75 5.75 14.25 2.25 10 2.25C5.71875 2.25 2.25 5.75 2.25 10C2.25 14.2812 5.71875 17.75 10 17.75C14.25 17.75 17.75 14.2812 17.75 10ZM9.09375 14.125C8.90625 14.3125 8.5625 14.3125 8.375 14.125L5.125 10.875C4.9375 10.6875 4.9375 10.3438 5.125 10.1562L5.84375 9.46875C6.03125 9.25 6.34375 9.25 6.53125 9.46875L8.75 11.6562L13.4375 6.96875C13.625 6.75 13.9375 6.75 14.125 6.96875L14.8438 7.65625C15.0312 7.84375 15.0312 8.1875 14.8438 8.375L9.09375 14.125Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledTick);
export default __webpack_public_path__ + "static/media/filled-tick.f1139c12.svg";
export { ForwardRef as ReactComponent };